import { Image, Link, View, StyleSheet, Text } from '@react-pdf/renderer';
import React from 'react';
import PDFRenderUtils from "utils/PDFRenderUtils";

const PDFTableCell = (props) => {
    const { text, horizontal, vertical, width, backgroundColor, border } = props;
    const { __totalElements, __elementsWidthArray } = props;
    const totalWidth = PDFRenderUtils.sumOfArray(__elementsWidthArray);
    const totalElementsThatHaveWidth = __elementsWidthArray.filter(width => width > 0).length;

    const styles = StyleSheet.create({
        headerCol: {
            display: 'flex',
            borderWidth: border,
            borderLeftWidth: 0,
            borderTopWidth: 0,
            borderBottomWidth: 0,
            borderStyle: "solid",
            borderColor: '#000000',
            marginRight: 0,
            //alignContent: "center",
            //justifyContent: "center"
            //backgroundColor: "#FF0000",
            //textAlign: "center",
            //verticalAlign: "end"
        },
        headerCell: {
            marginHorizontal: 5,
            marginVertical: 5,
            //fontSize: 16,
        },
    });


    let style = { minWidth: width + "%" };
    if (width) {
        style.width = width + "%";
        style.minWidth = width + "%";
        style.maxWidth = width + "%";
        style.flexGrow = 0;
        style.flexShrink = 0;
        style.flexBasis = width + "%";
    } else {
        const autoWidth = PDFRenderUtils.calculateWidth(totalWidth, __totalElements - totalElementsThatHaveWidth);
        style.width = autoWidth;
        style.minWidth = autoWidth;
        style.maxWidth = autoWidth;
        style.flexGrow = 0;
        style.flexShrink = 0;
        style.flexBasis = autoWidth;
    }
    if (horizontal === 'center' || horizontal === 'right' || horizontal === 'left') {
        style.textAlign = horizontal;
    }
    if (horizontal === 'center') {
        style.alignItems = 'center';
    }
    if (horizontal === 'right') {
        style.alignItems = 'flex-end';
    }
    switch (vertical) {
        case "start":
            style.justifyContent = "flex-start"
            break
        case "end":
            style.justifyContent = "flex-end"
            break
        case "center":
            style.justifyContent = "center"
            break
        default:
            style.justifyContent = "flex-start"
    }

    if (backgroundColor) {
        style.backgroundColor = backgroundColor;
    }
    const renderContent = () => {
        if (text && typeof text === "object" && text.__exportType === "image") {
            return (
                <Image
                    src={text.src}
                    style={{ width: text.width || 28, height: text.height || 28, objectFit: "contain", margin: 3 }}
                />
            );
        }
        if (text && typeof text === "object" && text.__exportType === "link") {
            return (
                <Link src={text.href} style={styles.headerCell}>
                    {text.label || "Lihat"}
                </Link>
            );
        }
        return <Text style={styles.headerCell}>{text}</Text>;
    };

    return (
        <>
            <View style={PDFRenderUtils.combineStyles(styles.headerCol, style)}>
                {renderContent()}
            </View>
        </>
    )
}



PDFTableCell.defaultProps = {
    width: 0,
    horizontal: 'left',
    vertical: "start",
    border: 1
}

export default PDFTableCell;
